import {setupWebViewJavascriptBridge, calcSize, updateJWT, toLogin} from '../../js/utils'

let moment = require('moment')
import Cookies from 'js-cookie'

// 校验环境
export const envMixin = {
  data() {
    return {
      isIos:
        navigator.userAgent.includes('wondercv_ios') ||
        this.$route.query.client === 'ios', // 是否为ios
      isAlipayClient: navigator.userAgent
        .toLocaleLowerCase()
        .includes('alipayclient'), // 是否为支付宝小程序
      isUCClient: navigator.userAgent.toLocaleLowerCase().includes('aliapp(uc'), // 是否为UC小程序
      isQuaReClient: navigator.userAgent.toLocaleLowerCase().includes('aliapp(quark'), // 是否为夸克小程序
      isQuickApp: navigator.userAgent
        .toLocaleLowerCase()
        .includes('com.wondercv'), // 判断是否为快应用
      isToutiao: navigator.userAgent
        .toLocaleLowerCase()
        .includes('toutiaomicroapp'), // 判断是否为头条小程序
      isQQMini:
        navigator.userAgent.includes('QQ') &&
        navigator.userAgent.toLocaleLowerCase().includes('miniprogram'), // 判断是否为qq小程序
      isBaidu: navigator.userAgent
        .toLocaleLowerCase()
        .includes('swan-baiduboxapp'), // 判断是否为百度小程序
      isWechatBrowser: navigator.userAgent.includes('MicroMessenger'), // 判断微信浏览器
      isSafariBrowser: navigator.userAgent.includes('Safari'), // 判断是否是 Safari 浏览器
      isAndroid: navigator.userAgent.includes('android_wondercv_app'), // 判断是否为安卓
      isAndroidBrowser: /(Android)/i.test(navigator.userAgent),
      isIosBrowser: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent),
      isReviewOfIos: false, // 判断ios是否审核中
      iosVersion: '', // ios的版本
      isWxMini: navigator.userAgent.includes('MicroMessenger') && navigator.userAgent.includes('miniProgram'), // 判断是否为微信小程序
      isRNApp: process.client ? this.$route.query.client === 'reactNative' : '', // 是否为ios
      loadingPageOver: false, // 定时器延迟加载页面，不然通过ua判断是否渲染的dom会闪一下
      versionShow: false,
      isAppEnv: !!window.ReactNativeWebView, //判断是不是RN环境
      mobileOS: '',    // 手机系统
      isHarmony: navigator.userAgent.includes('wondercvharmony') || location.href.includes('wondercvharmony')
    }
  },
  mounted() {
    let md = new MobileDetect(navigator.userAgent);
    this.mobileOS = md.os();
    setTimeout(async () => {
      this.loadingPageOver = true
    }, 0)
  },
  computed: {
    iosOrAndroidStyle() {
      return this.isAndroid || this.isIos
        ? {'padding-top': 0, 'margin-top': 0}
        : {}
    },
    iosOrAndroid() {
      return this.isAndroid || this.isIos
    },
    iosOrAndroidShow() {
      return !this.isIos && !this.isAndroid
    },
    isEnv() {
      // return `${this.isIos ? '苹果' : '安卓'}${this.isWxMini ? '微信小程序' : 'h5'}`
      return `${this.isWxMini ? 'miniprogram' : 'h5'}_${this.isIosBrowser ? 'ios' : 'android'}`
    }
  },
  methods: {
    iosBridgeSave() {
      this.handlerBridge('saveStore', {store: JSON.stringify(this.$store.state)})
    },
    iosBridgeGet() {
      if (this.isIos) {
        return new Promise(resolve => {
          this.handlerBridge('getStore', {}, store => {
            if (store) {
              let storeData = JSON.parse(store.data)
              this.$store.replaceState(Object.assign({}, storeData))
              resolve(1)
            }
          })
        })
      }
    },
    async iosReview() {
      let res = await this.$api.global.iosReview()
      if (this.isIos && res.in_review) this.isReviewOfIos = true
    },
    initIosVersion() {
      if (navigator.userAgent.includes('wondercv_ios')) {
        const index = navigator.userAgent.indexOf('app_version=')
        this.iosVersion = navigator.userAgent.substr(index + 12, 5)
        return navigator.userAgent.substr(index + 12, 5)
      }
    },
    routeReplace(url) {
      if (this.iosOrAndroid) {
        window.location.replace(url)
      } else {
        this.$router.replace(url)
      }
    },
    routeTo(url, needQuery) {
      if (this.isIos) {
        let queryUrl = url
        if (this.cv && this.cv.base && needQuery) {
          let cvInfo = {
            cvLang: this.cv.base.lang,
            cvType: this.cv.base.cv_type,
          }
          queryUrl += `${queryUrl.includes('?') ? '' : '?'}&cvInfo=${JSON.stringify(cvInfo)}&_token=${this.cv.base.token}`
        }
        window.location.href = process.env.VUE_APP_HOST + queryUrl
      } else if (this.isAndroid) {
        window.location.href = url
      } else {
        this.$router.push(url)
      }
    },
    iosUpdateDialog(newVersion) {
      let version = this.$route.query.version
      let uaVersion = this.initIosVersion()
      if (this.isIos && (version < newVersion || (uaVersion && uaVersion < newVersion))) {
        return true
      }
    },
    routeBack(url) {
      if (this.iosOrAndroid) {
        window.location.href = url
      } else {
        this.$router.back()
      }
    },
    getMiniEnv() {
      if (this.$wechat) {
        this.$wechat.miniProgram.getEnv(res => {
          this.isWxMini = res.miniprogram
        })
      }
    },
    handlerBridge(bridgeName, payload, callback) {
      if (this.isIos) {
        setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler(bridgeName,
            payload,
            function responseCallback(responseData) {
              if (callback) callback(responseData)
            })
        })
      }
    },
    registerBridge(bridgeName, callback, payload, dirData) {
      if (this.isIos) {
        setupWebViewJavascriptBridge(bridge => {
          bridge.registerHandler(bridgeName, (data, responseCallback) => {
            callback && callback(payload)
            responseCallback(dirData)
          })
        })
      }
    },
    cvRouter(token, editor) {
      if (!this.$route.query.version && this.isIos) {
        window.location.href = `${process.env.VUE_APP_LINK}/cvs/${token}/${editor || 'profiles'}`
        // this.routeTo(`${process.env.VUE_APP_LINK}/cvs/${ token }/profiles`)
      } else {
        this.routeTo(`/cvs/${token}/editor`)
      }
    }
  }
}
// 登录相关内容
export const loginMixin = {
  data() {
    return {
      alreadyLogged: Cookies.get("_t") || Cookies.get("_t_plugin")
    }
  },
  computed: {},
  methods: {
    verifyLogin(logged, callback, url, payload) {
      if (logged) {
        callback(payload)
      } else {
        toLogin(url)
        // this.$api.global
        // 	.storeLocation({ return_to: url })
        // 	.then(res => {
        // 		if (res.code === 1000) {
        // 			window.location.href = `${ process.env.VUE_APP_LINK }/signin/?type=login`
        // 		}
        // 	})
        // 	.catch(() => {
        // 		console.log('报错了！')
        // 	})
      }
    },
    // 各种小程序根据jwt&&jwt_timestamp 自动登录
    async miniprogramAutoLogin() {
      let ua = navigator.userAgent
      let isAlipay = ua.toLocaleLowerCase().includes('alipayclient')
      let isQuickApp = ua.toLocaleLowerCase().includes('com.wondercv');
      let isUCClient = ua.toLocaleLowerCase().includes('aliapp(uc') // 是否为UC小程序
      let isQuaReClient = ua.toLocaleLowerCase().includes('aliapp(quark') // 是否为夸克小程序
      let wxMini = ua.includes('MicroMessenger') && ua.includes('miniProgram')   // 是否微信小程序
      // 微信小程序
      if (wxMini) {
        let unionid = this.$route.query.miniprogram_unionid
        let jwt = this.$route.query.miniprogram_cc
        if (unionid) {
          this.logged = true
          let res = await this.$api.auth.miniprogramAutoLogin({unionid:unionid,app_type:'mini'})
          if (res.code === 1000) {
            await updateJWT({
              jwt: res.data.jwt,
              jwt_timestamp: res.data.jwt_timestamp,
              cookieEndTime: moment().add(14, 'd').valueOf()
            })
          } else {
            this.logged = false
            this.showToast('自动登录失败')
          }
        } else if (jwt) {
          await updateJWT({
            jwt: jwt,
            jwt_timestamp: moment().valueOf(),
            cookieEndTime: moment().add(14, 'd').valueOf()
          })
        }
      }
      // 支付宝小程序和快应用
      let { jwt, jwt_timestamp } = this.$route.query
      if (!!(jwt && jwt_timestamp) && (isAlipay || isQuickApp || isUCClient || isQuaReClient) ) {
        await updateJWT({
          jwt: jwt,
          jwt_timestamp: jwt_timestamp,
          cookieEndTime: moment().add(14, 'd').valueOf()
        })
      }
    },
    // 小程序自动登录
    // async miniProgramAutoLogin() {
    //   let ua = navigator.userAgent
    //   let wxMini = ua.includes('MicroMessenger') && ua.includes('miniProgram')
    //   let unionid = this.$route.query.miniprogram_unionid
    //   let jwt = this.$route.query.miniprogram_cc
    //   if (unionid && wxMini) {
    //     this.logged = true
    //     let res = await this.$api.auth.miniprogramAutoLogin({unionid:unionid,app_type:'mini'})
    //     if (res.code === 1000) {
    //       updateJWT({
    //         jwt: res.data.jwt,
    //         jwt_timestamp: res.data.jwt_timestamp,
    //         cookieEndTime: moment().add(14, 'd').valueOf()
    //       })
    //     } else {
    //       this.logged = false
    //       this.showToast('自动登录失败')
    //     }
    //   } else if (jwt && wxMini) {
    //     updateJWT({
    //       jwt: jwt,
    //       jwt_timestamp: moment().valueOf(),
    //       cookieEndTime: moment().add(14, 'd').valueOf()
    //     })
    //   }
    // },
    // 微信的授权
    async weChatAuthorization(scope, redirectUrl, state) {
      this.$api.user.getWeChatJsConfig({url: location.href}).then(res => {
        // 保存当前是那个公众号，cv/cv2
        if(res.data.account_type){
          this.$db.ls.set('openWeixinType', res.data.account_type)
        }
        let wechatAuthConfig = {
          appid: res.data.appId,
          redirect_uri: redirectUrl,
          response_type: 'code',
          scope: scope,
          state: state,
          connect_redirect: 1
        }
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?${this.stringify(
          wechatAuthConfig
        )}#wechat_redirect`
      })
    },
    // 微信授权之后调用rails登录接口
    async loginByWx() {
      try {
        let info = this.$db.ls.get('info')
        let code = this.$route.query.code
        let authorization = Cookies.get('_t')
        let openWeixinType = this.$db.ls.get('openWeixinType') // 读取是哪个公众号类型
        if (code && !authorization && info && info.type === 'login') {
          let res = await this.$api.auth.signInWechat({
            code,
            client: 'wechat_mobile_browser',
            account_type: !!openWeixinType ? openWeixinType : 'cv',
            // account_type: 'cv_account'
          })
          this.$db.ls.remove('openWeixinType')
          if (res.code === 1000) {
            updateJWT({
              jwt: res.data.jwt,
              jwt_timestamp: res.data.jwt_timestamp,
              cookieEndTime: 14 * 24 * 60 * 60
            })
            let {name, query} = this.$route
            if(res.data.new_account){
              this.$db.ls.set('offers_new_account', 'true')
            }
            if (res.data.new_account && name != 'campus-offers') {

              const Cookies = require('js-cookie')
              let allCookies = Cookies.get()
              let encodedAccounts = res.data.jwt && JSON.parse(window.atob(res.data.jwt.split('.')[1]))
              let accountTokens = encodedAccounts.User || {}
              let data = {}
              for (const [key, value] of Object.entries(allCookies)) {
                if (key.startsWith('sem_')) {
                  data[key] = value
                }
              }
              if (!!Object.keys(data).length) {
                try {
                  this.$api.io.reportedSemData({
                    data: {
                      ...data,
                      cv_account_token: accountTokens.c_t,
                      hr_account_token: accountTokens.h_t
                    },
                    data_type: 'sem'
                  })
                } catch (error) {
                  console.log(error)
                }
              }
            }
            this.alreadyLogged = true
            this.$db.ls.remove('info')
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 微信授权登录之后调用机构号邀请登录
    async groupLoginByWx(params, isWx, name, link) {
      try {
        let info = this.$db.ls.get('_group_login')
        let code = this.$route.query.code
        let openWeixinType = this.$db.ls.get('openWeixinType') // 读取是哪个公众号类型
        params.code = code
        // 如果有学号校验参数中加入学号
        let studentNumber = this.$db.ls.get('_student_number')
        if (studentNumber) {
          params.student_id = studentNumber
        }
        // 公众号类型
        if(!!openWeixinType){
          params.account_type = openWeixinType
        }
        this.$db.ls.remove('_student_number')
        this.$db.ls.remove('openWeixinType')
        // 是否已经登录  没有登陆调取注册接口  已经登录弹窗提示仅新用户可领取
        if (code && info && info.type === 'login') {
          let res = await this.$api.user.setGroupUserSignUp(params)
          if (res.code === 1000) {
            await updateJWT({
              jwt: res.data.jwt,
              jwt_timestamp: res.data.jwt_timestamp,
              cookieEndTime: 14 * 24 * 60 * 60
            })
            this.$db.ls.remove('_group_login')
            this.showToast('领取成功');
            // 判断是否是新用户
            if (link) {
              setTimeout(() => {
                window.location.href = link
              }, 1500)
            }
            // if (res.data.new_account) {
            //   // 是否微信环境，是的话跳转至邀请成功页面扫描关注公众号，不是的话跳转至APP下载引导页
            //   if (isWx) {
            //     setTimeout(() => {
            //       this.$router.push({path: '/group/invitation/success', query: {groupName: name}})
            //     }, 1500)
            //   } else {
            //     setTimeout(() => {
            //       this.$router.push({path: '/welcome/to_app'})
            //     }, 1500)
            //   }
            // } else {
            //   this.showToast('非常抱歉，<br>本活动仅新用户可参与')
            // }
            // this.alreadyLogged = true
          } else {
            if (res.message.indexOf('账户已存在') > -1) {
              this.showToast('非常抱歉，<br>本活动仅新用户可参与')
            } else {
              this.showToast(res.message)
            }
          }
        } else {
          // this.showToast('非常抱歉，<br>本活动仅新用户可参与')
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 整理query参数
    stringify(obj) {
      let str = ''
      for (let key in obj) {
        str += `${key}=${obj[key]}&`
      }
      return str.slice(0, -1)
    },
    // 小程序或者H5中未登录跳转登录
    needLogin() {
      if (this.isWxMini || this.isWechatBrowser) {
        let state = 'login'
        // let redirectUrl = `${process.env.VUE_APP_LINK}${window.location.pathname}`
        let redirectUrl = `${process.env.VUE_APP_HOST}${window.location.pathname}`
        this.$db.ls.set('info', {type: 'login'})
        this.weChatAuthorization('snsapi_userinfo', redirectUrl, state)
      } else {
        toLogin(window.location.href)
      }
    }
  }
}
// 事件
export const eventMixin = {
  created() {
    this.changeStoreData()
  },
  methods: {
    changeStoreData() {
      if (!this.isIos) {
        window.removeEventListener('beforeunload', this.setStoreData)
        if (this.$db.ls.get('store')) {
          this.$store.replaceState({...this.$db.ls.get('store')})
          this.$db.ls.remove('store')
        }
        window.addEventListener('beforeunload', this.setStoreData)
      }
    },
    setStoreData() {
      this.$db.ls.set('store', this.$store.state)
    }
  },
  beforeDestroy() {
    this.$db.ls.remove('store')
    window.removeEventListener('beforeunload', this.setStoreData)
  }
}
// 绑定到window上的事件
export const windowEventMixin = {
  created() {
    this.resizePage()
  },
  methods: {
    resizePage() {
      window.addEventListener('resize', calcSize)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', calcSize)
  }
}
// 微信相关配置
export const WxMixin = {
  methods: {
    wx_share(shareObj, desc, url) {
      if (!shareObj.imgUrl)
        shareObj.imgUrl = 'https://files.wondercv.com/App%20Icon@2x.png'
      let enjoyUrl = url || window.location.href
      let haveDesc = {desc, link: enjoyUrl, ...shareObj}
      let newShareObj = {...shareObj, link: enjoyUrl}
      this.$api.user.getWeChatJsConfig({url: location.href})
        .then(res => {
          setTimeout(() => {
            let data = {
              debug: false,
              ...res.data,
              jsApiList: [
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'chooseWXPay'
              ]
            }
            this.$wechat.config(data)
            this.$wechat.onMenuShareAppMessage(haveDesc)
            this.$wechat.onMenuShareTimeline(newShareObj)
          }, 1000)
        })
      // this.$wechat.onMenuShareAppMessage(haveDesc)
      // this.$wechat.onMenuShareTimeline(newShareObj)
    },
    getEnv() {
      this.$wechat.miniProgram.getEnv(res => {
        this.miniEnv = res.miniprogram
      })
    }
  }
}
// H5引导下载APP
export const downloadAPPMixin = {
  data () {
    return {
      mobileType: ''   // 手机系统：iOS/Android
    }
  },
  mounted () {
    let md = new MobileDetect(navigator.userAgent);
    this.mobileType = md.os();
  },
  methods: {
    // 唤醒APP
    openApp(linkParams = {ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&id=${this.$route.params.token}&listType=system&open_type=bbs`, android: `android://h5/open?id=${this.$route.params.token}&type=bbs`}, needReload) {
      // iOS
      if (this.mobileType === 'iOS') {
        // window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
        window.location.href = linkParams.ios
        if (needReload) {
          setTimeout(() => {
            window && window.location.reload();
          }, 1000)
        }
        // AndroidOS
      } else {

        // 调用安卓协议打开APP  没有安装APP则跳转应用宝
        window.location.href = linkParams.android
        let t = Date.now();

        setTimeout(() => {
          if (Date.now() - t < 1200) {
            window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
          }
        }, 1000);
      }
    },
  }
}

